import React from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { CheckoutHeader } from '../HeaderContainer/CheckoutHeader';



export const CbGuestRegisterForm = () => {
    const [showTooltip, setShowTooltip] = useState(false);
const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    return (
        
            <div class="c-container">
                <CheckoutHeader/>
                <div class="row justify-content-center c-account-page c-school-page c-shipping-page">
                    <div class="col-12 col-md-11 my-md-5 my-2">
                        <div class="row">
                            <div class="col-12 col-md-8" id="visibleElement">
                                {/* <div id="shipping-formError" class="alert alert-danger mb-5">
                                </div> */}

                                <div class="row">
                                    <div class="col-6 col-md-6 text-left mb-3">
                                        <h1 class="c-account-heading">Shipping Address</h1>
                                    </div>

                                    <div class="col-6 col-md-6 text-end mb-3">

                                        <Link to="/checkout/int/save.jsp" class="brightBlue">

                                            <i class="fa fa-globe"></i>
                                            Need to Ship Internationally?
                                        </Link>
                                    </div>

                                </div>
                                <form method="POST" name="" action="" id="" class="c-account-page" data-hs-cf-bound="true">
                                    <div style={{display:'none'}}>
                            
                                </div><div style={{display:'none'}}>
                                       
                                    </div>
                                    <div class="row g-3 g-md-5 mb-3">
                                        <div class="col-md-6">
                                            <label for="firstName" class="form-label">First Name</label>
                                            <input maxlength="19" name="" id="firstName" type="text" value="" class="form-control" />
                                           
                                        </div>
                                        <div class="col-md-6">
                                            <label for="lastName" class="form-label">Last Name</label>
                                            <input maxlength="19" name="" id="lastName" type="text" value="" class="form-control" />
                                        </div>
                                    </div>

                                    <div class="row g-3 g-md-5 mb-3">
                                        <div class="col-md-6">
                                            <label for="email" class="form-label">Email</label>
                                            <input maxlength="255" name="" id="emailAddress" type="email" value="" class="form-control" />
                                        </div>
                                        <div class="col-md-6">
                                            <label for="phone" class="form-label">Phone</label>
                                            <input maxlength="12" name="" id="phoneNumber" type="text" value="" class="form-control" />
                                        </div>
                                    </div>

                                    <div class="row g-3 g-md-5 mb-3">
                                        <div class="col-md-12">
                                            <label for="company" class="form-label">School or Company (optional)</label>
                                            <input maxlength="40" name="" id="companyName" type="text" value="" class="form-control" />
                                        </div>
                                    </div>

                                    <div class="row g-3 g-md-5 mb-3">
                                        <div class="col-md-6">
                                            <label for="address" class="form-label">Street Address</label>
                                            <input maxlength="40" name="" id="address1" type="text" value="" class="form-control" />                                        
                                            </div>

                                        <div class="col-md-6">
                                            <label for="address2" class="form-label">Attention</label>
                                            <input maxlength="40" name="" id="address2" placeholder="Ex: John Smith Bio Lab or PO 15596" type="text" value="" class="form-control" />
                                        </div>
                                    </div>

                                    <div class="row g-3 g-md-5 mb-3">
                                        <div class="col-md-6">
                                            <label for="zip" class="form-label">Zip</label>
                                            <input maxlength="10" name="" id="postalCode" type="text" value="" class="form-control" />
                                        </div>
                                        <div class="col"></div>
                                    </div>

                                    <div class="row g-3 g-md-5 mb-4 mb-lg-0">
                                        <div class="col-12 col-md-6">
                                            <label for="city" class="form-label">City</label>
                                            <input maxlength="30" name="" id="city" type="text" value="" class="form-control" />
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <label for="state" class="form-label">State</label>
                                            <select name="" id="state" class="form-control form-select">

                                                <option value="AL">
                                                    AL - Alabama
                                                </option>

                                                <option value="AK">
                                                    AK - Alaska
                                                </option>

                                                <option value="AZ">
                                                    AZ - Arizona
                                                </option>

                                                <option value="AR">
                                                    AR - Arkansas
                                                </option>

                                                <option value="CA">
                                                    CA - California
                                                </option>

                                                <option value="CO">
                                                    CO - Colorado
                                                </option>

                                                <option value="CT">
                                                    CT - Connecticut
                                                </option>

                                                <option value="DE">
                                                    DE - Delaware
                                                </option>

                                                <option value="DC">
                                                    DC - District of Columbia
                                                </option>

                                                <option value="FL">
                                                    FL - Florida
                                                </option>

                                                <option value="GA">
                                                    GA - Georgia
                                                </option>

                                                <option value="HI">
                                                    HI - Hawaii
                                                </option>

                                                <option value="ID">
                                                    ID - Idaho
                                                </option>

                                                <option value="IL">
                                                    IL - Illinois
                                                </option>

                                                <option value="IN">
                                                    IN - Indiana
                                                </option>

                                                <option value="IA">
                                                    IA - Iowa
                                                </option>

                                                <option value="KS">
                                                    KS - Kansas
                                                </option>

                                                <option value="KY">
                                                    KY - Kentucky
                                                </option>

                                                <option value="LA">
                                                    LA - Louisiana
                                                </option>

                                                <option value="ME">
                                                    ME - Maine
                                                </option>

                                                <option value="MD">
                                                    MD - Maryland
                                                </option>

                                                <option value="MA">
                                                    MA - Massachusetts
                                                </option>

                                                <option value="MI">
                                                    MI - Michigan
                                                </option>

                                                <option value="MN">
                                                    MN - Minnesota
                                                </option>

                                                <option value="MS">
                                                    MS - Mississippi
                                                </option>

                                                <option value="MO">
                                                    MO - Missouri
                                                </option>

                                                <option value="MT">
                                                    MT - Montana
                                                </option>

                                                <option value="NE">
                                                    NE - Nebraska
                                                </option>

                                                <option value="NV">
                                                    NV - Nevada
                                                </option>

                                                <option value="NH">
                                                    NH - New Hampshire
                                                </option>

                                                <option value="NJ">
                                                    NJ - New Jersey
                                                </option>

                                                <option value="NM">
                                                    NM - New Mexico
                                                </option>

                                                <option value="NY" selected="selected">
                                                    NY - New York
                                                </option>

                                                <option value="NC">
                                                    NC - North Carolina
                                                </option>

                                                <option value="ND">
                                                    ND - North Dakota
                                                </option>

                                                <option value="OH">
                                                    OH - Ohio
                                                </option>

                                                <option value="OK">
                                                    OK - Oklahoma
                                                </option>

                                                <option value="OR">
                                                    OR - Oregon
                                                </option>

                                                <option value="PA">
                                                    PA - Pennsylvania
                                                </option>

                                                <option value="RI">
                                                    RI - Rhode Island
                                                </option>

                                                <option value="SC">
                                                    SC - South Carolina
                                                </option>

                                                <option value="SD">
                                                    SD - South Dakota
                                                </option>

                                                <option value="TN">
                                                    TN - Tennessee
                                                </option>

                                                <option value="TX">
                                                    TX - Texas
                                                </option>

                                                <option value="UT">
                                                    UT - Utah
                                                </option>

                                                <option value="VT">
                                                    VT - Vermont
                                                </option>

                                                <option value="VA">
                                                    VA - Virginia
                                                </option>

                                                <option value="WA">
                                                    WA - Washington
                                                </option>

                                                <option value="WV">
                                                    WV - West Virginia
                                                </option>

                                                <option value="WI">
                                                    WI - Wisconsin
                                                </option>

                                                <option value="WY">
                                                    WY - Wyoming
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-3 mb-md-0">
                                        <div class="col-12 col-md-6 mb-lg-4">
                                            <div class="form-check c-register-check">
                                                <input name="" style={{display:'none'}} id="defaultshipping" type="checkbox" value="" />
                                                <input name="" id="blankCheckbox" type="checkbox" value="" class="form-check-input position-static" />
                                                <label class="form-check-label form-check-label-padding" for="blankCheckbox">&nbsp;Use this address for billing</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row g-3 g-md-5 mb-4 mt-md-1">
                                        <div class="col-md-6 d-grid">
                                            <button type="submit" class="btn btn-primary block" onclick="">Continue</button>
                                        </div>
                                    </div>
                                    <div style={{display:'none'}}>
                                        </div>
                                </form>
                            </div>

                            <div class="col-12 col-md-4 my-order-section" id="orders1">
                                <div class="c-shipping-box">


                                    <div class="row g-0 mb-40">
                                        <div class="col-4 col-md-4">
                                            <h2 class="c-shipping-order-title">My Order</h2>
                                        </div>
                                        <div class="col-3 col-md-3">
                                            (<span class="c-shipping-order-item">6</span>
                                            items)
                                        </div>
                                        <div class="col-5 col-md-5 text-end">
                                            <Link class="c-shipping-order-edit" to="/checkout/cart.jsp">edit shopping cart</Link>
                                        </div>
                                    </div>

                                    <form id="applyPromotionCode2" data-hs-cf-bound="true">
                                        <div class="row g-2 mb-2">

                                            <div class="col-7 col-md-7">
                                                <label class="form-label form-hipping-label" for="promotionalCode">
                                                    Apply a Promotional Code
                                                </label>
                                                <input type="text" class="form-control quantity-error" id="promotionalCode" value="" placeholder="enter promo code" />
                                                <Link class="c-shipping-order-remove promotional-code-remove fw-normal" style={{display:'none'}}>
                                                    remove code
                                                </Link>
                                            </div>
                                            <div class="col-5 col-md-5 text-end">
                                                <input name="applyCodeBtn" type="submit" id="promotional-code-submit" onclick="" value="apply code" class="btn btn-secondary block c-shipping-btn" />
                                            </div>
                                            {/* <label class="error error-promotion">
                                                You did not enter a promotion code.
                                            </label> */}
                                        </div>
                                    </form>
                                    <div class="c-promotion-code-height">
                                        <div class="row justify-content-center promotional-code-messaging messaging" style={{display:'none'}}>
                                            <div class="col-12 col-md-12 messageDiv">
                                                <p class="c-success text-center"></p>
                                                <p class="c-error text-center">
                                                    The code entered does not qualify for your current cart, is invalid or has expired.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div id="order-summary">

                                        <div class="loader-image">
                                            {/* <div class="loadingAnimation">
                                                <span class="spinner-border" role="status" aria-hidden="true"></span>
                                                <span class="visually-hidden">Loading...</span>
                                            </div> */}
                                            <div class="c-order-summary">
                                                <p class="c-order-label">
                                                    Subtotal:
                                                </p>
                                                <p class="c-order-value">
                                                    $693.35
                                                </p>
                                            </div>



                                            <div class="c-order-summary">
                                                <p class="c-order-label" style={{display:'flex'}}>
                                                    Shipping Estimate:
                                                    <span class="c-tooltip" onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                    style={{ position: 'relative', marginRight: '-30px', padding: '5px' }}>
                                    <i class="fa fa-question-circle"></i>
                                    {showTooltip && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '-60px',
                                                left: '28px',
                                                background: '#F3E5AB',
                                                color: '#000000',
                                                padding: '5px',
                                                borderRadius: '3px',
                                                zIndex: '1',
                                                width: '200px',
                                                fontSize: '0.7em',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '50px',
                                                    left: '30%',
                                                    marginLeft: '0px',
                                                    width: '0',
                                                    height: '0',
                                                    borderTop: '5px solid transparent',
                                                    borderBottom: '5px solid transparent',
                                                    borderRight: '7px solid #333',
                                                }}
                                            ></div>
                                            <p>Freight cost is calculated based on your destination and product weight. We then apply any applicable contract discounts.</p><br/>
                                            <p>Orders containing hazardous materials include a single fee of $19.75 for required special packaging.</p><br/>
                                            <p>Alaska &amp; Hawaii Customers: All orders are shipped via 2nd Day Air.</p>
                                        </div>
                                    )}
                                </span></p>
                                                <p class="c-order-value">
                                                    $69.73
                                                </p></div>
                                            <div class="c-order-summary">
                                                <p class="c-order-label">
                                                    Tax Estimate:
                                                    <span class="c-tooltip" data-bs-toggle="tooltip" data-bs-html="true" aria-label="Tax is calculated according to your shipping zip code."><i class="bi bi-question-circle-fill"></i></span>
                                                </p>
                                                <p class="c-order-value">
                                                    $65.82
                                                </p>
                                            </div>


                                            <div class="mt-4">


                                                <div class="c-order-summary">
                                                    <p class="c-order-total">
                                                        TOTAL:
                                                    </p>
                                                    <p class="c-order-amount">
                                                        $828.90
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="c-shipping-guest">
                                    <i class="fa fa-lock"></i>
                                    <span>
                                        Secure Checkout Shopping is always safe and secure
                                    </span>
                                </div>
                            </div>

                        </div>

                        <div id="checkoutSpacer"></div>


                    </div>
                    {/* <div id="loading">
                        <div class="d-flex align-items-center justify-content-center loading-cont">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <div class="col-12"><span>Loading...</span></div>
                        </div>
                    </div> */}

                    <div class="modal fade c-modal" id="default-modal" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                            <div class="modal-content">
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                </button>
                                <div class="modal-body">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}
